import { Tag } from 'antd';
import type {
  CapabilityStatus,
  ErrorClassify,
  JobStatus,
  ProviderStatus,
  WorkerStatus,
} from '../api/types';

export function JobStatusTag({ status }: { status: JobStatus }) {
  const map: Record<JobStatus, { color: string; label: string }> = {
    queued: { color: 'default', label: 'Đang chờ' },
    assigned: { color: 'blue', label: 'Đã giao worker' },
    processing: { color: 'processing', label: 'Đang xử lý' },
    awaiting_callback: { color: 'purple', label: 'Chờ callback' },
    completed: { color: 'success', label: 'Hoàn tất' },
    failed: { color: 'error', label: 'Thất bại' },
    cancelled: { color: 'warning', label: 'Đã hủy' },
  };
  const it = map[status] ?? { color: 'default', label: status };
  return <Tag color={it.color}>{it.label}</Tag>;
}

export function WorkerStatusTag({ status }: { status: WorkerStatus }) {
  const map: Record<WorkerStatus, { color: string; label: string }> = {
    online: { color: 'success', label: 'Trực tuyến' },
    offline: { color: 'error', label: 'Ngoại tuyến' },
    disabled: { color: 'default', label: 'Đã tắt' },
  };
  const it = map[status] ?? { color: 'default', label: status };
  return <Tag color={it.color}>{it.label}</Tag>;
}

export function ProviderStatusTag({ status }: { status: ProviderStatus }) {
  const map: Record<ProviderStatus, { color: string; label: string }> = {
    active: { color: 'success', label: 'Hoạt động' },
    disabled: { color: 'default', label: 'Đã tắt' },
    maintenance: { color: 'warning', label: 'Bảo trì' },
  };
  const it = map[status] ?? { color: 'default', label: status };
  return <Tag color={it.color}>{it.label}</Tag>;
}

export function CapabilityStatusTag({ status }: { status: CapabilityStatus }) {
  const map: Record<CapabilityStatus, { color: string; label: string }> = {
    active: { color: 'success', label: 'Hoạt động' },
    disabled: { color: 'default', label: 'Đã tắt' },
  };
  const it = map[status] ?? { color: 'default', label: status };
  return <Tag color={it.color}>{it.label}</Tag>;
}

export function ErrorClassTag({ classify }: { classify: ErrorClassify | string }) {
  const map: Record<string, { color: string; label: string }> = {
    source: { color: 'volcano', label: 'Lỗi nguồn' },
    user: { color: 'blue', label: 'Lỗi người dùng' },
    retry: { color: 'gold', label: 'Thử lại' },
    fatal: { color: 'red', label: 'Nghiêm trọng' },
  };
  const it = map[classify] ?? { color: 'default', label: classify };
  return <Tag color={it.color}>{it.label}</Tag>;
}

export function DeliveryStatusTag({ status }: { status: string }) {
  const map: Record<string, { color: string; label: string }> = {
    pending: { color: 'default', label: 'Đang chờ' },
    success: { color: 'success', label: 'Thành công' },
    delivered: { color: 'success', label: 'Đã gửi' },
    failed: { color: 'error', label: 'Thất bại' },
    retrying: { color: 'gold', label: 'Đang thử lại' },
  };
  const it = map[status] ?? { color: 'default', label: status };
  return <Tag color={it.color}>{it.label}</Tag>;
}
